import { useConnection } from "@solana/wallet-adapter-react";
import { HubbleLendingPositionFetcher } from "@stepfinance/lending";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo } from "react";

import { useEnrichedWallet } from "../../contexts/enrichedWallet";
import { useRefreshContext } from "../../contexts/refresh";
import { getTokenBySymbol } from "../../utils/tokenInfo";

export const useHubbleLending = () => {
  const { connection } = useConnection();
  const { connected, publicKey } = useEnrichedWallet();
  const { refreshID } = useRefreshContext();

  const hubbleLendingFetcher = useMemo(() => {
    if (publicKey && connected) {
      return new HubbleLendingPositionFetcher({ connection, publicKey, getTokenBySymbol });
    }
  }, [connected, connection, publicKey]);

  const { data, refetch } = useQuery(
    ["hubble-lending", publicKey?.toBase58()],
    async () => {
      if (hubbleLendingFetcher) {
        return await hubbleLendingFetcher.fetchLendingPositions();
      }
      return {};
    },
    { retry: false, enabled: hubbleLendingFetcher !== undefined },
  );

  useEffect(() => {
    void refetch();
  }, [refetch, refreshID]);

  return { collateral: data ?? {}, yieldFarms: {} };
};
